import React from "react";
import "./ProfileSkeleton.css"; // we'll add CSS below

const ProfileSkeleton = () => {
  return (
    <div className="tutors-app">
      <div className="profile-wrapper skeleton-wrapper">
        {/* Back button placeholder */}
        <div className="back-btn-skeleton" />

        {/* Page title */}
        <div className="page-title-skeleton" />

        {/* Cover */}
        <div className="profile-cover skeleton-cover" />

        {/* Header section */}
        <div className="profile-header skeleton-header">
          <div className="profile-left-vertical">
            {/* Avatar */}
            <div className="profile-avatar-skeleton" />

            <div className="profile-details-vertical">
              {/* Name & rating */}
              <div className="name-rating-row-skeleton">
                <div className="profile-name-skeleton" />
                <div className="rating-text-skeleton" />
              </div>

              {/* Location */}
              <div className="location-text-skeleton" />

              {/* Badges */}
              <div className="badge-row-skeleton">
                <div className="pill-skeleton" />
                <div className="pill-skeleton" />
                <div className="pill-skeleton" />
              </div>
            </div>
          </div>

          <div className="profile-right-clean">
            {/* Program type pills */}
            <div className="program-type-row-skeleton">
              <div className="pill-skeleton" />
              <div className="pill-skeleton" />
            </div>

            {/* Contact buttons */}
            <div className="contact-row-skeleton">
              <div className="button-skeleton" />
              <div className="circle-button-skeleton" />
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="profile-tabs-skeleton">
          {["Overview", "Testimonials", "Career", "Map", "Media"].map((tab) => (
            <div key={tab} className="tab-btn-skeleton" />
          ))}
        </div>

        {/* Content area */}
        <div className="profile-content-skeleton">
          <div className="overview-layout-skeleton">
            <div className="overview-left-skeleton">
              <div className="section-title-skeleton" />
              <div className="bio-lines">
                <div className="skeleton-line" />
                <div className="skeleton-line" />
                <div className="skeleton-line short" />
              </div>
            </div>

            <div className="overview-right-clean-skeleton">
              <div className="section-title-skeleton" />
              <div className="info-block-skeleton">
                <div className="info-label-skeleton" />
                <div className="pill-row-skeleton">
                  <div className="pill-skeleton" />
                  <div className="pill-skeleton" />
                </div>
              </div>

              <div className="info-block-skeleton">
                <div className="info-label-skeleton" />
                <div className="pill-row-skeleton">
                  <div className="pill-skeleton" />
                  <div className="pill-skeleton" />
                  <div className="pill-skeleton" />
                </div>
              </div>

              <div className="info-block-skeleton address-block">
                <div className="address-header-skeleton">
                  <div className="info-label-skeleton" />
                </div>
                <div className="address-lines">
                  <div className="skeleton-line" />
                  <div className="skeleton-line" />
                  <div className="skeleton-line short" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileSkeleton;